import { usePublicMenusForLocation } from '@Pacific-Web-Services/component-library'
import { useLocation } from 'react-router-dom'
import { useWayfarerAccount } from '../hooks/useWayfarerAccount'

export default function useMenus() {
  const { data: account } = useWayfarerAccount()
  const locationId = account?.locations.find((l) => l.name == 'Bird Rock')?.id!
  const { data } = usePublicMenusForLocation(locationId, {
    enabled: !!locationId,
  })
  const { pathname } = useLocation()
  let menus = data?.filter((menu) => menu.id === 2 || menu.id === 3)
  if (pathname === '/tacos') {
    menus = data?.filter((menu) => menu.id === 9 || menu.id === 15)
  }
  if (pathname === '/breakfastsandwiches') {
    menus = data?.filter((menu) => menu.id === 18)
  }
  // Stable Thanksgiving link; update the menu id each year (2026 = 26)
  if (pathname === '/thanksgiving' || pathname === '/thanksgiving2025') {
    menus = data?.filter((menu) => menu.id === 26)
  }
  if (pathname === '/christmas') {
    menus = data?.filter((menu) => menu.id === 23)
  }
  if (pathname === '/bouquets') {
    menus = data?.filter((menu) => menu.id === 24)
  }
  if (pathname === '/easter') {
    menus = data?.filter((menu) => menu.id === 25)
  }
  if (pathname === '/checkout') {
    menus = data
  }
  return menus
}
